import React from 'react';
import { Layout, Menu } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { 
  DashboardOutlined, 
  UserOutlined, 
  ProjectOutlined, 
  LogoutOutlined,
  SettingOutlined,
  FileTextOutlined,
  FolderOutlined,
  CalendarOutlined,
} from '@ant-design/icons';
import { useAuthStore } from '../../store/useAuthStore';

const { Header, Sider, Content } = Layout;

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuthStore();

  const handleMenuClick = ({ key }) => {
    if (key === 'logout') {
      logout();
      navigate('/login');
    } else {
      navigate(key);
    }
  };

  const menuItems = [
    {
      key: '/admin',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
    },
    {
      key: '/admin/employees',
      icon: <UserOutlined />,
      label: 'Employees',
    },
    {
      key: '/admin/projects',
      icon: <ProjectOutlined />,
      label: 'Projects',
    },
    {
      key: '/admin/timeline',
      icon: <CalendarOutlined />,
      label: 'Projects Timeline',
    },
    {
      key: '/admin/reports',
      icon: <FileTextOutlined />,
      label: 'Reports',
    },
    {
      key: '/admin/documents',
      icon: <FolderOutlined />,
      label: 'Documents',
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      danger: true,
    },
  ];

  return (
    <Layout className="min-h-screen">
      <Sider
        breakpoint="lg"
        collapsedWidth="0"
        theme="dark"
        width={250}
      >
        <div className="p-4 text-center border-b border-gray-700">
          <h3 className="text-lg font-semibold text-white mb-4">One Qodequay</h3>
          <p className="text-gray-300 text-sm">{user?.name}</p>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={handleMenuClick}
          className="border-r-0"
        />
      </Sider>
      <Layout>
        <Header className="bg-white shadow-sm px-6 flex items-center justify-between">
          <h1 className="text-xl font-semibold text-gray-800 m-0">
            Timesheet Admin System
          </h1>
          <div className="flex items-center space-x-4">
            <span className="text-gray-600">
              Welcome, {user?.name}
            </span>
            <SettingOutlined 
              className="text-gray-600 cursor-pointer hover:text-blue-600" 
              onClick={() => navigate('/admin/profile')}
              title="Go to Profile"
            />
          </div>
        </Header>
        <Content className="bg-gray-50">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
